<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			asset: ISbStoryData[];
			bullet: string;
			bullet_position: 'own-line' | 'same-line';
			bullet_variant: 'orange-text' | 'green-background';
			headline: string;
			text: ISbRichtext;
		}>['content'];
	}

	let { content }: Props = $props();

	function getBulletTextClasses(variant: typeof content.bullet_variant): string {
		if (variant === 'orange-text') {
			return 'text-orange-3 text-[32px]/[100%] tracking-[-.64px] font-semibold';
		}

		return 'font-serif text-white text-[28px]/[100%] tracking-[-.56px]';
	}
</script>

<article use:editable={content}>
	{#if content.asset?.length > 0}
		<div class="mb-5 overflow-hidden rounded-2xl"><Blok content={content.asset[0]} /></div>
	{/if}
	<div>
		<div
			class="mb-2 flex gap-3"
			class:flex-col={content.bullet_position === 'own-line'}
			class:items-center={content.bullet_position === 'same-line'}
		>
			{#if content.bullet?.length > 0}
				<div
					class:flex={content.bullet_variant === 'green-background'}
					class:items-center={content.bullet_variant === 'green-background'}
					class:justify-center={content.bullet_variant === 'green-background'}
					class:h-8={content.bullet_variant === 'green-background'}
					class:w-8={content.bullet_variant === 'green-background'}
					class:rounded-full={content.bullet_variant === 'green-background'}
					class:bg-green-3={content.bullet_variant === 'green-background'}
					class="self-start"
				>
					<span class={getBulletTextClasses(content.bullet_variant)}>{content.bullet}</span>
				</div>
			{/if}
			{#if content.headline?.length > 0}
				<h1 class="text-[24px]/[110%] font-semibold text-brown-2">{content.headline}</h1>
			{/if}
		</div>
		<div class="info-text text-[18px]/[140%] text-brown-2 empty:hidden">
			<SbRichtext text={content.text} />
		</div>
	</div>
</article>

<style lang="scss">
	div.info-text {
		:global {
			a {
				text-decoration: underline;
				font-weight: theme('fontWeight.semibold');
			}

			p {
				margin: theme('spacing.2') 0;
			}
		}
	}
</style>
